import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Crater4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CRATER4;
}

export default Crater4PoiTileEntity;
